import axios from 'axios';
import endpointNames from "../configs/serverUrls";

//url variable
const baseUrl = endpointNames.product;
// get User Token
// let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));



//get all managers
const getAllProducts = async() => {
        let response;
        const config = {
            headers: {Authorization: `Bearer ${token}`}
        };
    await axios.get(baseUrl + 's', config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

const getProductDetails = async () => {
    const productId = JSON.parse(localStorage.getItem('productId'));
    // setProductName(productId);
    console.log("product: ", productId);
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl + '/' + productId, config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}


//get all managers

const getAllProductPackages = async () => {
    const productId = JSON.parse(localStorage.getItem('productId'));
    // setProductName(productId);
    console.log("product: ", productId);
    let response;
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl+'/'+productId+'/packages', config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}





//add product
const addProduct = async(request) => {
    let response;

    await axios.post(baseUrl, {
        'name': request.name,
        'adminFee': request.adminFee,
        'productType': request.productType,
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//update product
const updateProduct = async(request) => {
    let response;
    console.log("request: ",request);
    await axios.put(baseUrl+'/update/'+request.id,request,{
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//delete manager
const deleteProduct = async(id) => {
    let response;
    await axios.delete(baseUrl+'delete-product/'+id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

export default {
    getAllProducts, addProduct, updateProduct, deleteProduct, getAllProductPackages, getProductDetails
}
